<cue-declarative-map-marker pane="poi" [zIndexOffset]="activeZIndexOffset" [geoJson]="geoJson()" [focused]="focused()">
  <div
    *cueDeclarativeMapMarkerTemplate
    class="map-start-point-host"
    (click)="onHostClick($event)"
    [style.transform]="'scale(' + scale() + ')'"
    [style.-webkit-transform]="'scale(' + scale() + ')'"
  >
    <div class="start-point">
      @if (startPoint().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Icon) {
        <img class="map-btn-icon-wrapper icon" [src]="startPoint().icon | imageDimensions: { width: 50, height: 50 }" />
      }
      @if (startPoint().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Image) {
        <img
          class="map-btn-icon-wrapper map-btn-icon-wrapper--img"
          [src]="startPoint().image | imageDimensions: { height: 50 }"
        />
      }
      @if (startPoint().showOnFloorplanAbove === showOnFloorplanAboveStartTargetEnum.Name) {
        <span class="map-btn-name">{{ startPoint().name | localizedString }}</span>
      }

      @if (isKioskMode()) {
        <div class="kiosk-container">
          <div class="text" data-cy="kiosk-you-are-here">
            {{ translation.navigation.youAreHere | transloco }}
          </div>
          <cue-icon [icon]="ICONS.cueStart" />
        </div>
      } @else {
        <div class="start-point-marker">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_393_816)">
              <path
                d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9966 8.81846 22.7312 5.76821 20.4815 3.51852C18.2318 1.26883 15.1815 0.00344108 12 0ZM12 22C10.0222 22 8.08879 21.4135 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92893C6.32746 3.53041 8.10929 2.578 10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.7612C17.6541 3.51808 19.2159 4.79981 20.3147 6.4443C21.4135 8.08879 22 10.0222 22 12C21.9971 14.6513 20.9426 17.1931 19.0679 19.0679C17.1931 20.9426 14.6513 21.9971 12 22Z"
                fill="#820B8A"
              />
              <path
                d="M18 12C18 15.3137 15.3137 18 12 18C8.6863 18 6.00001 15.3137 6.00001 12C6.00001 8.68629 8.6863 6 12 6C15.3137 6 18 8.68629 18 12Z"
                fill="#820B8A"
              />
            </g>
            <defs>
              <clipPath id="clip0_393_816"><rect width="24" height="24" fill="white" /></clipPath>
            </defs>
          </svg>
        </div>
      }
    </div>
  </div>
</cue-declarative-map-marker>
